/**
 * Per-unit discount amount, rounded **up** to the next whole currency unit.
 * Mirrors the ceil'd per-unit discount the server computes in
 * `apps/api/src/order/order.service.ts`, so client and server totals agree.
 * Returns 0 when there is no discount (null / undefined / 0).
 */
export function unitDiscount(price:number,discountPercent?:number|null):number{
	return discountPercent?Math.ceil(price*(discountPercent/100)):0;
}

/**
 * Net price for `quantity` units. The per-unit discount is ceil'd first and only
 * then multiplied by the quantity — the same order the server applies, so a
 * multi-unit line never drifts by the rounding remainder.
 */
export function discountedPrice(price:number,discountPercent?:number|null,quantity=1):number{
	return quantity*(price-unitDiscount(price,discountPercent));
}
